export default __webpack_public_path__ + "static/media/Math-Quiz.23dbb5d9.gif";